import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { SuperComponent } from '../../super/super.component';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import * as XLSX from 'xlsx'
@Component({
  selector: 'app-vacation-request',
  templateUrl: './vacation-request.component.html',
  styleUrls: ['./vacation-request.component.scss']
})
export class VacationRequestComponent extends SuperComponent implements OnInit {
  isSubmitting: boolean = false;
  isValid: boolean = false;
  isChecking: boolean = false;
  bulkResults: any = null;
isUploadingBulk: boolean = false;
  model: any = {
    employeeId: null,
    holidayTypeId: null,
    startDate: new Date(),
    endDate: new Date(),
    vacationReson: ''
  };
  
  HolidayTypeDropDown: any[] = [];
  employeeDropDown: any[] = [];

  constructor(
    gt: genericCustomStoreService,
    translate: TranslateService,
    Objects: ObjectsService,
    Notify: NotifyService
  ) { 
    super(Objects, translate, gt);
    
    this.onEmployeeChanged = this.onEmployeeChanged.bind(this);
    this.onFieldChanged = this.onFieldChanged.bind(this);
    
    gt.getdropdowndata("Employee").subscribe((res: any[]) => {
      this.employeeDropDown = res || [];
    });
  }

  ngOnInit(): void {
  }

  onEmployeeChanged(e: any) {
    const employeeId = e?.value;

    // إعادة تعيين نوع الإجازة والتحقق
    this.model.holidayTypeId = null;
    this.HolidayTypeDropDown = [];
    this.isValid = false;

    if (!employeeId) return;

    this.gt.GetAllowedHolidayTypesDropDown(employeeId).subscribe({
      next: (res: any[]) => {
        this.HolidayTypeDropDown = res || [];
        console.log('Holiday Types:', this.HolidayTypeDropDown);
      },
      error: (err) => {
        console.error('Error loading holiday types:', err);
        this.HolidayTypeDropDown = [];
      }
    });
  }

  checkAvailability() {
    if (!this.model.employeeId || !this.model.holidayTypeId ||
        !this.model.startDate || !this.model.endDate) {
      return;
    }

    this.isChecking = true;
    this.isValid = false;

    const dto = {
      employeeId: Number(this.model.employeeId),
      holidayTypeId: Number(this.model.holidayTypeId),
      startDate: this.model.startDate,
      endDate: this.model.endDate,
      vacationReson: this.model.vacationReson || ''
    };

    this.gt.checkVacation(dto).subscribe({
      next: (res: any) => {
        if (res === true) {
          this.isValid = true;
        }
        else if (res?.isValid === true) {
          this.isValid = true;
        }
        else {
          this.isValid = false;
          console.log('Validation failed:', res);
        }
        this.isChecking = false;
      },
      error: (err) => {
        console.error('Check error:', err);
        this.isChecking = false;
        this.isValid = false;
      }
    });
  }

 
  onFieldChanged() {
    this.isValid = false;
  }

  submit() {
    if (!this.isValid || this.isSubmitting) return;

    this.isSubmitting = true;

    const dto = {
      employeeId: Number(this.model.employeeId),
      holidayTypeId: Number(this.model.holidayTypeId),
      startDate: this.model.startDate,
      endDate: this.model.endDate,
      vacationReson: this.model.vacationReson || ''
    };

    this.gt.Addvacation(dto).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;
        alert('تم إضافة الإجازة بنجاح');
        this.resetForm();
      },
      error: (err) => {
        this.isSubmitting = false;

        const msg =
          err?.error?.message ||
          err?.error?.title ||
          (err?.error?.errors ? JSON.stringify(err.error.errors) : null) ||
          'حدث خطأ ما';

        alert('خطأ: ' + msg);
        console.error('Add vacation error:', err);
      }
    });
  }

  resetForm() {
    this.model = {
      employeeId: null,
      holidayTypeId: null,
      startDate: new Date(),
      endDate: new Date(),
      vacationReson: ''
    };

    this.HolidayTypeDropDown = [];
    this.isValid = false;
    this.isChecking = false;
    this.isSubmitting = false;
  }

onFileUploaded(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawData: any[] = XLSX.utils.sheet_to_json(worksheet);

        const items = rawData.map(row => ({
            employeeCode: String(row['EmployeeCode'] || row['كود الموظف'] || '').trim(),
            holidayTypeId: Number(row['HolidayTypeId'] || row['نوع الاجازة']),
            startDate: this.formatExcelDate(row['StartDate'] || row['تاريخ البداية']),
            endDate: this.formatExcelDate(row['EndDate'] || row['تاريخ النهاية']),
            vacationReson: row['VacationReson'] || row['السبب'] || ''
        }));

        this.uploadBulk(items);
    };
    reader.readAsArrayBuffer(file);
    event.target.value = '';
}

// دالة مساعدة لضبط التواريخ القادمة من إكسل
formatExcelDate(excelDate: any) {
    if(!excelDate) return new Date();

    if(typeof excelDate === 'number') {
        return new Date((excelDate - 25569) * 86400 * 1000);
    }
    return new Date(excelDate);
}

triggerUpload() { 
  document.getElementById('excelUpload')!.click(); 
}

downloadTemplate() {
  const template = [
    {
      'EmployeeCode': 'EMP001',
      'HolidayTypeId': 1,
      'StartDate': '01/02/2024',
      'EndDate': '05/02/2024',
      'VacationReson': 'إجازة سنوية'
    },
    {
      'EmployeeCode': 'EMP002',
      'HolidayTypeId': 1,
      'StartDate': '10/02/2024',
      'EndDate': '12/02/2024',
      'VacationReson': 'ظروف عائلية'
    }
  ];

  const ws = XLSX.utils.json_to_sheet(template);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'قالب طلبات الإجازة');

  ws['!cols'] = [
    { wch: 15 }, // EmployeeCode
    { wch: 15 }, // HolidayTypeId
    { wch: 15 }, // StartDate
    { wch: 15 }, // EndDate
    { wch: 30 }  // VacationReson
  ];

  XLSX.writeFile(wb, 'قالب_طلبات_الإجازة.xlsx');
}
exportFailedRows() {
  if (!this.bulkResults?.errors?.length) return;

  const failedData = this.bulkResults.errors.map((e: any) => ({
    'EmployeeCode':  e.rowData?.employeeCode  || e.employeeCode || '',
    'HolidayTypeId': e.rowData?.holidayTypeId || '',
    'StartDate':     e.rowData?.startDate     || '',
    'EndDate':       e.rowData?.endDate       || '',
    'VacationReson': e.rowData?.vacationReson || '',
    'الأخطاء':       e.errors?.join(', ')     || ''
  }));

  const ws = XLSX.utils.json_to_sheet(failedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'الأخطاء');

  ws['!cols'] = [
    { wch: 15 }, // EmployeeCode
    { wch: 14 }, // HolidayTypeId
    { wch: 14 }, // StartDate
    { wch: 14 }, // EndDate
    { wch: 30 }, // VacationReson
    { wch: 50 }  // الأخطاء
  ];

  XLSX.writeFile(wb, 'إجازات_فاشلة_لإعادة_التعديل.xlsx');
}

uploadBulk(items: any[]) {
    this.isUploadingBulk = true;
    this.bulkResults = null;

 
    this.gt.AddVacationBulk({ items }).subscribe({
        next: (res: any) => {
            this.bulkResults = res;
            this.isUploadingBulk = false;
            if(res.failedCount === 0) {
                 alert('تم رفع جميع الطلبات بنجاح');
            }
        },
        error: (err) => {
            this.isUploadingBulk = false;
            alert('حدث خطأ أثناء الرفع الجماعي');
            console.error(err);
        }
    });
}

}